import CryptoJS from 'crypto-js';
import { extractUserPayloadData, getPublicApiUrlForEnvironment } from './init-utils.js';
import { WEB_SDK_VERSION } from '../version.js';
const generateFingerprint = () => {
    // User-Agent
    const userAgent = navigator.userAgent;
    // Screen Resolution and Color Depth
    const screenResolution = `${screen.width}x${screen.height}`;
    const colorDepth = screen.colorDepth;
    // Timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Language
    const language = navigator.language || navigator.languages.join(',');
    // Canvas Fingerprinting
    const getCanvasFingerprint = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (ctx !== null) {
            ctx.textBaseline = 'top';
            ctx.font = '16px Arial';
            ctx.fillStyle = '#f60';
            ctx.fillRect(125, 1, 62, 20);
            ctx.fillStyle = '#069';
            ctx.fillText('Browser Fingerprint', 2, 15);
            ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
            ctx.fillText('Browser Fingerprint', 4, 17);
        }
        const dataUrl = canvas.toDataURL();
        return CryptoJS.SHA256(dataUrl).toString();
    };
    const canvasFingerprint = getCanvasFingerprint();
    // Combine all the fingerprints
    return CryptoJS.SHA512(userAgent + screenResolution + colorDepth + timezone + language + canvasFingerprint).toString();
};
const collectInitInformation = () => {
    const sdkVersion = WEB_SDK_VERSION;
    const platform = 'Desktop';
    const language = navigator.language;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Generate or retrieve a unique device ID
    const deviceId = localStorage.getItem('deviceId') || generateFingerprint();
    localStorage.setItem('deviceId', deviceId); // Save it for future use
    return {
        sdkVersion,
        platform,
        language,
        timezone,
        deviceId,
    };
};
export const logSDKInit = async (applicationContext) => {
    const { sdkVersion, platform, language, timezone, deviceId } = collectInitInformation();
    const userPayloadData = extractUserPayloadData(applicationContext.authToken, null, true);
    if (!userPayloadData) {
        return;
    }
    let userAuthCode = '';
    if ('registration_auth_code' in userPayloadData) {
        userAuthCode = userPayloadData['registration_auth_code'];
    }
    const requestPayload = {
        userAuthCode: userAuthCode,
        userProperties: {
            sdkVersion: sdkVersion,
            platform: platform,
            language: language,
            timezone: timezone,
            deviceId: deviceId,
        },
    };
    try {
        const baseUrl = getPublicApiUrlForEnvironment(applicationContext.sdkEnvironment);
        const response = await fetch(`${baseUrl}/v2/analytics/sdkInit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestPayload),
            mode: 'no-cors'
        });
        if (!response.ok) {
            return;
        }
        await response.json();
        // eslint-disable-next-line no-empty
    }
    catch (error) {
    }
};
